



















import Vue from "vue";
// @ts-ignore
import { VContainer, VRow, VCol } from "vuetify/lib";
import { defineComponent } from "@vue/composition-api";
import { castComponent } from "@/lib/helpers";
import BaseSlowConnection from "@/components/BaseSlowConnection";

Vue.component("VContainer", castComponent(VContainer));
Vue.component("VRow", castComponent(VRow));
Vue.component("VCol", castComponent(VCol));
Vue.component("BaseSlowConnection", castComponent(BaseSlowConnection));

export default defineComponent({
  name: "BasePageTwoColumn",
  props: {
    leftClass: { type: String },
    rightClass: { type: String },
    isLoading: { type: Boolean, default: false },
    noDescription: { type: Boolean, default: false },
  },
});
